module.exports = __webpack_public_path__ + "static/distributor.580ebc8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/gravittem/distributor.svg
// module id = 223
// module chunks = 13643350389075 141989620174219